import { ApiRoutes } from '@/services/ApiRoutes.js';
import { BackendAPI, BackendDownloadFileAPI } from '@/services/BackendAPI.js';

export default {
  all(data = {}) {
    return BackendAPI('get', ApiRoutes.student.all(), data);
  },
  get(id) {
    return BackendAPI('get', ApiRoutes.student.get(id));
  },
  create(data) {
    return BackendAPI('post', ApiRoutes.student.create(), data);
  },
  registerTrial(data) {
    return BackendAPI('post', ApiRoutes.student.registerTrial(), data);
  },
  update(id, data) {
    return BackendAPI('put', ApiRoutes.student.update(id), data);
  },
  changePassword(id, password) {
    let passData = { password: password };
    return BackendAPI('put', ApiRoutes.student.changePassword(id), passData);
  },
  validateId(id) {
    return BackendAPI('get', ApiRoutes.student.validateId(id));
  },
  learningHistory(id) {
    return BackendAPI('get', ApiRoutes.student.learningHistory(id));
  },
  testImages(data) {
    return BackendAPI('post', ApiRoutes.student.testImages(), data);
  },
  sendMessage(data) {
    return BackendAPI('post', ApiRoutes.student.sendMessage(), data);
  },
  deleteMessage(id) {
    return BackendAPI('delete', ApiRoutes.student.deleteMessage(id));
  },
  certificatePDF(data) {
    return BackendDownloadFileAPI('post', ApiRoutes.student.certificatePDF(), data);
  },
  changeAffiliation(data) {
    return BackendAPI('post', ApiRoutes.student.changeAffiliation(), data);
  },
  deactivate(data) {
    return BackendAPI('post', ApiRoutes.student.deactivate(), data);
  },
  reactivate(data) {
    return BackendAPI('post', ApiRoutes.student.reactivate(), data);
  },
  upgradeLevel(data) {
    return BackendAPI('post', ApiRoutes.student.upgradeLevel(), data);
  },
  downgradeLevel(data) {
    return BackendAPI('post', ApiRoutes.student.downgradeLevel(), data);
  },
  upgradeFiguredTeachingMaterial(data) {
    return BackendAPI('post', ApiRoutes.student.upgradeFiguredTeachingMaterial(), data);
  },
  upgradeNextFiguredTeachingMaterial(data) {
    return BackendAPI('post', ApiRoutes.student.upgradeNextFiguredTeachingMaterial(), data);
  },
  clearNextFiguredTeachingMaterial(data) {
    return BackendAPI('post', ApiRoutes.student.clearNextFiguredTeachingMaterial(), data);
  },
  changePreRegistrationTime(data) {
    return BackendAPI('post', ApiRoutes.student.changePreRegistrationTime(), data);
  },
  clearPreRegistrationTime(data) {
    return BackendAPI('post', ApiRoutes.student.clearPreRegistrationTime(), data);
  },
  resetPasswordAndExportPdf(data) {
    return BackendDownloadFileAPI('post', ApiRoutes.student.resetPasswordAndExportPdf(), data);
  },
  // Note: for testing purpose, please delete after finish testing
  // testScheduledFunction() {
  //   return BackendDownloadFileAPI('delete', ApiRoutes.student.testScheduledFunction());
  // },
};
